import React, { useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { SmoothScrollProvider } from "@/components/SmoothScroll";
import SplashScreen from "@/components/SplashScreen";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Products from "@/components/sections/Products";
import EditorialMarquee from "@/components/sections/EditorialMarquee";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import Process from "@/components/sections/Process";
import Gallery from "@/components/sections/Gallery";
import Testimonials from "@/components/sections/Testimonials";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

function App() {
  const [splashDone, setSplashDone] = useState(false);

  return (
    <SmoothScrollProvider>
      <div className="App bg-cream text-charcoal antialiased" data-testid="app-root">
        <SplashScreen onDone={() => setSplashDone(true)} />
        <Navbar />
        <main>
          <Hero splashDone={splashDone} />
          <About />
          <Products />
          <EditorialMarquee />
          <WhyChooseUs />
          <Process />
          <Gallery />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
        <FloatingWhatsApp />
        <div className="grain-overlay" aria-hidden="true" />
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: {
              background: "#1F5E3A",
              color: "#FAF7F0",
              border: "1px solid rgba(201,162,39,0.4)",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </div>
    </SmoothScrollProvider>
  );
}

export default App;
